import { AccordionDetails, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material';
import React from 'react';

const Discussion: React.FunctionComponent<any> = ({ handleCheck, isDisable, validationObj, disable }) => {
  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checklist-radio-actions">
        <Grid md={12}>
          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Enrollment
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_enrol"
                  value={validationObj.stdy_imvrp_pid_enrol}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_enrol == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_enrol == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_enrol_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_enrol_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_enrol_comm }}
              />
            </Grid>
          </Grid>

          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Study Updates
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_study_up"
                  value={validationObj.stdy_imvrp_pid_study_up}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_study_up == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_study_up == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_study_up_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_study_up_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_study_up_comm }}
              />
            </Grid>
          </Grid>

          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Changes in or Training of Staff
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_staff"
                  value={validationObj.stdy_imvrp_pid_staff}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_staff == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_staff == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_staff_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_staff_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_staff_comm }}
              />
            </Grid>
          </Grid>
          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              PI Oversight
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_oversight"
                  value={validationObj.stdy_imvrp_pid_oversight}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_oversight == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_oversight == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_oversight_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_oversight_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_oversight_comm }}
              />
            </Grid>
          </Grid>

          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Issues identified at site (e.g., concerning Informed consent, source notes, eCRF entry and query
              resolution timelines, study drug etc.)
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_issues"
                  value={validationObj.stdy_imvrp_pid_issues}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_issues == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_issues == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_issues_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_issues_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_issues_comm }}
              />
            </Grid>
          </Grid>

          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Study Procedures
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_sproc"
                  value={validationObj.stdy_imvrp_pid_sproc}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_sproc == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_sproc == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_sproc_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_sproc_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_sproc_comm }}
              />
            </Grid>
          </Grid>

          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              SAEs
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_sae"
                  value={validationObj.stdy_imvrp_pid_sae}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_sae == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_sae == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_sae_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_sae_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_sae_comm }}
              />
            </Grid>
          </Grid>

          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Protocol Deviations
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_pd"
                  value={validationObj.stdy_imvrp_pid_pd}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_pd == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_pd == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_pd_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_pd_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_pd_comm }}
              />
            </Grid>
          </Grid>

          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Study Subject Concerns
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_sub_concern"
                  value={validationObj.stdy_imvrp_pid_sub_concern}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_sub_concern == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_sub_concern == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_sub_concern_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_sub_concern_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_sub_concern_comm }}
              />
            </Grid>
          </Grid>

          <Grid container mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Additional notes
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_pid_add"
                  value={validationObj.stdy_imvrp_pid_add}
                  onChange={e => handleCheck(e, 'section11')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_add == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_pid_add == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvrp_pid_add_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_pid_add_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section11')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_pid_add_comm }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default Discussion;
